/**
 *
 *  Bottom Navigation Link
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 07/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import { NavLink } from "react-router-dom";

export default function BottomNavLink({ to, linkIcon, text, onClick }) {
  return (
    <NavLink
      to={to}
      isActive={(match, location) => {
        if (!match) {
          return false;
        }

        if (match.url === "/account" && !match.isExact) {
          return false;
        }

        return true;
      }}
      className={(isActive) =>
        `nav-link tbk-decoration-none tbk-relative tbk-block tbk-w-7 tbk-text-blue-dark tbk-text-center${
          isActive
            ? " after:tbk-absolute after:tbk-bottom-[-11px] after:tbk-block after:tbk-h-0.5 after:tbk-w-full after:tbk-bg-coral after:tbk-content-['']"
            : ""
        }`
      }
      onClick={onClick}
    >
      <div className="tbk-flex tbk-flex-col tbk-items-center">
        <div className="tbk-text-blue-dark">{linkIcon}</div>
        <div className="tbk-text-small tbk-text-blue-dark tbk-no-underline">
          {text}
        </div>
      </div>
    </NavLink>
  );
}
